<template>
  <div class="login form-body" data-cy="login-again-page">
    <div class="login-box">
      <div class="login-part">
        <div class="center-items">
          <div class="title-part">
            <img class="meDaPro-logo" src="@assets/MeDaPro_logo.svg" alt="" />
          </div>
          <div class="logout-part">
            <div class="logout-wrapper">
              <div class="logout-title">
                <p class="text-center mb-0">{{ $t("logoutPageTitle") }}</p>
                <div class="divider w-75"></div>
              </div>
              <img src="@assets/Logout_Banner.svg" alt="" />
            </div>
            <b-btn variant="primary" type="button" class="signin-again-btn" @click.prevent="navigateToLoginPage" data-cy="login-again-btn">
              <img src="@assets/account-logout.svg" />
              {{ $t("loginAgain") }}
            </b-btn>
          </div>
        </div>
      </div>
      <div class="footer-part">
        <div>
          <div class="version-label">
            {{ clientVersion }}
          </div>
        </div>
        <img class="itb-logo" src="@assets/logo2.svg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  methods: {
    navigateToLoginPage() {
      this.$router.push({
        name: "login",
        query: { go: this.$route?.query?.go }
      });
    }
  },
  computed: {
    ...mapState("metadata", ["version", "config"]),
    clientVersion() {
      const versionPrefix = "20";
      const versionArray = this.version.split(".").slice(0, 3);

      // Remove trailing zeros
      for (let i = versionArray.length - 1; i >= 0; i--) {
        if (versionArray[i] === "0") {
          versionArray.pop();
        } else {
          break;
        }
      }

      return versionPrefix.concat(versionArray.join("."));
    }
  }
};
</script>
